import React, {Component} from 'react';
import dayjs from 'dayjs';
import Big from 'big.js';
import BootStrapPagedTable from '../../../cmp/BootStrapPagedTable';
import Label from '../../../auth/components/Label';
import queryString from 'query-string';
import CurrencyNumber from '../../../cmp/CurrencyNumber';
import {FormattedMessage} from 'react-intl';
import Modal from '../../../cmp/Modal';
import {getItem, removeItem, setItem} from '../../../../tools/storage';

class VisitsAnalysis extends Component {

    state = {
        filteredVisits: [],
        aggregate_by: getItem('custom_query') || 'referrer_domain',
        sort_by: 'conversion-desc',
        custom_query: getItem('custom_query'),
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visits !== prevProps.visits) {
            this.applyFilter()
        }
    }

    componentDidMount() {
        if (this.props.visits.length > 0) {
            this.applyFilter()
        }
    }


    applyFilter = () => {
        this.setState({loading: true});
        setTimeout(() => {
            const visits = this.props.visits.map((item) => {
                const landing_query = item.landing_page && item.landing_page.startsWith("http") ? queryString.parse(new URL(item.landing_page).search) : {}
                return {
                    ...item,
                    date: dayjs(item.site_last_visit).format("YYYY-MM-DD"),
                    referrer_domain: item.referrer ? new URL(item.referrer).host : '',
                    ...landing_query
                }
            });
            //apply aggregation;
            const {sort_by, aggregate_by} = this.state;
            const aggregate = this.aggregate(aggregate_by, visits);
            const data = Object.keys(aggregate).map((key) => {
                let num_orders = 0;
                let num_visits = 0;
                let total_commission = Big(0);
                aggregate[key].forEach((item) => {
                    if (item.converted && item.status === "approved") {
                        num_orders += 1;
                        total_commission = total_commission.plus(item.affiliate_commission);
                    }
                    num_visits += 1;
                })
                let conversion_percent = num_visits > 0 ? Big(num_orders).times(100).div(num_visits).round() : 0;
                return {
                    agg: key,
                    num_orders,
                    num_visits,
                    total_commission: total_commission.toString(),
                    conversion_percent: conversion_percent.toString(),
                }
            })

            this.setState({filteredVisits: data.sort(this.sort(sort_by)), loading: false})
        }, 300)
    }

    aggregate = (key, items) => {
        const map = {};
        items.forEach((item) => {
            const k = item[key] || '';
            if (!map[k]) {
                map[k] = []
            }
            map[k].push(item)
        })
        return map;
    }


    sort = (sorter) => {
        switch (sorter) {
            case "conversion-desc":
                return this.sortConversionDesc;
            case "commission-desc":
                return this.sortCommissionDesc;
            case "orders-desc":
                return this.sortOrderNumberDesc;
            case "visits-desc":
                return this.sortVisitsDesc;
            case "date-desc":
            default:
                return this.sortDateDesc
        }
    }

    sortDateAsc = (a, b) => {
        return this.sortDateDesc(a, b) * -1;
    }

    sortDateDesc = (a, b) => {
        return dayjs(b.agg).unix() - dayjs(a.agg).unix()
    }
    sortVisitsDesc = (a, b) => {
        return b.num_visits - a.num_visits;
    }
    sortConversionDesc = (a, b) => {
        return b.conversion_percent - a.conversion_percent;
    }
    sortOrderNumberDesc = (a, b) => {
        return b.num_orders - a.num_orders
    }

    sortCommissionDesc = (a, b) => {
        return b.total_commission - a.total_commission;
    }
    sortConversionAsc = (a, b) => {
        return this.sortCommissionDesc(a, b) * -1
    }

    setAggregation = e => {
        if (e.target.value === "custom_query") {
            this.showModal()
        } else {
            this.setState({aggregate_by: e.target.value}, this.applyFilter)
        }
    }

    setSorter = e => {
        this.setState({
            sort_by: e.target.value,
            filteredVisits: this.state.filteredVisits.sort(this.sort(e.target.value))
        });
    }

    aggComponent = () => {
        switch (this.state.aggregate_by) {
            case "date":
                return <FormattedMessage id={"Date"}/>;
            case "referrer":
                return <FormattedMessage id={"Origin"}/>;
            case "referrer_domain":
                return <FormattedMessage id={"Domain"}/>;
            case "source":
                return <FormattedMessage id={"Source"}/>;
            case "landing_page":
                return <FormattedMessage id={"Landing Page"}/>;
            case "utm_source":
                return "UTM Source";
            case "utm_campaign":
                return "UTM Campaign";
            case "utm_terms":
                return "UTM Terms";
            case "utm_medium":
                return "UTM medium";
            case "utm_content":
                return "UTM Content";
            default:
                return this.state.aggregate_by;
        }
    }
    showModal = () => {
        this.setState({custom_modal: true})
    }

    hideModal = () => {
        this.setState({custom_modal: false})
    }

    onChange = (key) => (e) => {
        this.setState({[key]: e.target.value})
    }
    addCustomQuery = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this.state.custom_query) {
            setItem('custom_query', this.state.custom_query)
            this.setState({aggregate_by: this.state.custom_query}, this.applyFilter)
        } else {
            removeItem('custom_query');
            this.setState({aggregate_by: 'referrer_domain'}, this.applyFilter)
        }
        this.hideModal()
    }


    render() {
        const columns = [
            {
                title: <span>{this.aggComponent()}</span>,
                dataIndex: 'agg'
            },
            {
                title: 'Orders',
                dataIndex: 'num_orders',
                type: 'number',
            },
            {
                title: 'Visits',
                dataIndex: 'num_visits',
                type: 'number',
            },
            {
                title: 'Commission',
                dataIndex: 'total_commission',
                type: 'number',
                render: a => <CurrencyNumber value={a}/>
            },
            {
                title: 'Conversion',
                type: 'number',
                dataIndex: 'conversion_percent',
                render: a => a + "%"
            }
        ]


        return (
            <div>
                <div className="row align-items-center mb-2">
                    <div className="col-md-4">
                        <h3><FormattedMessage id={"Traffic Analysis"}/></h3>
                    </div>
                    <div className="col-md-4">
                        <Label><FormattedMessage id={"Aggregate By"}/></Label>
                        <select className={"form-control"} value={this.state.aggregate_by}
                                onChange={this.setAggregation}>

                            <FormattedOption value="referrer">Origin</FormattedOption>
                            <FormattedOption value="referrer_domain">Origin Domain</FormattedOption>
                            <FormattedOption value="source">Source</FormattedOption>
                            <FormattedOption value="utm_source">UTM Source</FormattedOption>
                            <FormattedOption value="utm_campaign">UTM Campaign</FormattedOption>
                            <FormattedOption value="utm_medium">UTM Medium</FormattedOption>
                            <FormattedOption value="utm_content">UTM Content</FormattedOption>
                            <FormattedOption value="utm_term">UTM Term</FormattedOption>
                            <FormattedOption value="date">Date</FormattedOption>
                            <FormattedOption value="landing_page">Landing Page</FormattedOption>
                            {
                                this.state.custom_query &&
                                <option value={this.state.custom_query}>Landing Page
                                    - {this.state.custom_query}</option>
                            }
                            <FormattedOption value={"custom_query"}>Custom Query Param</FormattedOption>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <Label><FormattedMessage id={"Sort By"}/></Label>
                        <select className="form-control" value={this.state.sort_by} onChange={this.setSorter}>
                            <FormattedOption value="orders-desc">Orders</FormattedOption>
                            <FormattedOption value="visits-desc">Visits</FormattedOption>
                            <FormattedOption value="conversion-desc">Conversion</FormattedOption>
                            {
                                this.state.aggregate_by === "date" ?
                                    <FormattedOption value="date-desc">Date</FormattedOption>
                                    : null
                            }
                            <FormattedOption value="commission-desc">Commission</FormattedOption>
                        </select>
                    </div>
                </div>
                <Modal onSubmit={this.addCustomQuery} visible={this.state.custom_modal} onClose={this.hideModal}
                       title={"Landing Page - Custom Query Parameter"}>
                    <div className="form-group">
                        <Label><FormattedMessage id={"Query Parameter"}/></Label>
                        <input type="text" placeholder={"eg. ref"} value={this.state.custom_query}
                               onChange={this.onChange('custom_query')} className="form-control"/>
                    </div>
                </Modal>
                <BootStrapPagedTable loading={this.state.loading} bordered small dataSource={this.state.filteredVisits} columns={columns}/>
            </div>
        );
    }
}

function FormattedOption({value, children}) {
    return <FormattedMessage id={children}>
        {(message) => <option value={value}>{message}</option>}
    </FormattedMessage>
}

export default VisitsAnalysis;
